export default __webpack_public_path__ + "static/media/facebook.7af49882.svg";